import {makeRequest} from "../helpers/network_utils";
import {GET_REQUEST} from "../values/globals";
import {getUrl, parseErrorResponse, showAlert, throttle} from "../helpers/helper_functions";

const $ = window.$;

export const onMount = (self, initUrl, key = "books") => {
    self.setState({
        loading: true
    })
    getData(initUrl, self, key);
    detectScroll(self, key);
}

/**
 * @param {string} url
 * @param {React.Component} self
 * @param {string|number} key
 * @param {boolean} [goingNext]
 */
const getData = (url, self, key, goingNext) => {

    makeRequest(GET_REQUEST, url, {}, response => {
        const res = response.data;
        if (res.data) {
            let myObj = {
                first: res.links.first,
                last: res.links.last,
                next: res.links.next,
                prev: res.links.prev
            }

            const theData = self.state[key] || [];
            const prevData = [...theData];
            if (goingNext)
                myObj[key] = prevData.concat(res.data);
            else
                myObj[key] = res.data;
            self.setState(myObj);
        }

    }, error => {
        showAlert('error', 'Error', parseErrorResponse(error))
    }, () => {
        self.setState({
            loading: false,
            loadingNext: false,
        })
    })
}

const detectScroll = (self, key) => {
    $(window).scroll(() => {
        if ($(window).scrollTop() >= $(document).height() - $(window).height() - 300) {
            loadMoreContent(self, key);
        }
    });
}

const loadMoreContent = throttle((self, key) => {
    const {next, loadingNext} = self.state;
    if (next && !loadingNext) {
        self.setState({
            loadingNext: true
        })
        getData(getUrl(next), self, key, true);
    }
}, 1000);